import '../css/distributors.scss';
import {render} from 'preact';
import {DistributorApp} from '@containers/Distributors';
import PageNavigation from '@components/common/PageNavigation';
import Modal from '@plugins/modal';
import axios from 'axios';

document.addEventListener( 'DOMContentLoaded', () => {

    PageNavigation.initialize( '#header--main' );

    const groupedList = document.getElementById( 'distributor-search--container' );

    if ( groupedList ) {
        groupedList.innerHTML = '';
        render( <DistributorApp countryId={groupedList.dataset.countryId}/>, groupedList );
    }

    // initialize content modals for countries we avoid linking directly to the distributor page
    const distributorModalLinks = document.querySelectorAll( '[data-source-url]' );
    distributorModalLinks.forEach( link => {
        link.addEventListener( 'click', ( e ) => {
            e.preventDefault();
            getDistributorContent( link.dataset.sourceUrl );
        } );
    } );

    const distributeMetaLinks = document.querySelectorAll( '[data-country-meta]' );
    console.log( 'distributeMetaLinks', distributeMetaLinks.length );

    const regionSelect = document.getElementById( 'region-select' );
    regionSelect.addEventListener( 'change', ( e ) => {
        const region = e.target.value;

        distributeMetaLinks.forEach( item => {
            const itemRegion = item.dataset.countryMeta?.split( '|' )[0];
            item.classList.remove( 'hidden' );
            item.classList.add( 'flex' );

            if ( region !== itemRegion && region !== '' ) {
                item.classList.add( 'hidden' );
                item.classList.remove( 'flex' );
            }
        } );
    } );

} );

async function getDistributorContent ( url ) {
    try {
        const {data} = await axios.get( url );

        const parser = new DOMParser();
        const doc = parser.parseFromString( data, 'text/html' );
        const fragment = doc.querySelector( '.distributor-container' );

        Modal.getInstance().open( {
            content: `<div class="modal-pop modal-body">${fragment.innerHTML}</div>`,
            width: 640
        } );
    }
    catch ( err ) {
        window.location.href = url;
    }
}
